export default {
  indonesia: require("../assets/indonesia.svg"),
  english: require("../assets/english.svg"),
};
